
import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Store from './store';
import Actions from './actions';
import { publicUrl } from '../../../client/utils';

const propTypes = {
  location: PropTypes.object,
};
const STATIC_PAGE_PATH = process.env.CMC_PORTAL_STATIC_PAGE_ABSOLUTE_PATH || '/';
const AUTHENTICATED_PAGE_PATH = process.env.CMC_PORTAL_AUTHENTICATED_PAGE_ABSOLUTE_PATH || '/';
//api docs path has changed when accessed from static environment destinations
const DOCUMENTATION_PATH = STATIC_PAGE_PATH!=='/' ? STATIC_PAGE_PATH + 'documentation/v1/' : '/api/v1/';
class Navbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = Store.getState();

    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleUserMenu = this.toggleUserMenu.bind(this);
    this.state.collapsed = true;
    this.state.collapsedUserMenu = true;
  }

  onStoreChange() {
    this.setState(Store.getState());
  }

  componentDidMount() {

    this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));
  }

  componentWillUnmount() {
    this.unsubscribeStore();

    Actions.resetStore();
  }

  isPathActive(pathPattern) {

    let isActive = false;

    if (typeof pathPattern === 'string') {
      isActive = this.props.location.pathname === pathPattern;
    }
    else {
      isActive = this.props.location.pathname.match(pathPattern);
    }

    return ClassNames({
      active: isActive,
    });
  }

  toggleMenu() {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  }

  toggleUserMenu() {
    this.setState({
      collapsedUserMenu: !this.state.collapsedUserMenu,
    });
  }

  onLogOutClick(e){
    e.preventDefault();
    Actions.logout();
  }

  render() {
    const collapsed = this.state.collapsed;
    const classOne = collapsed ? 'collapse navbar-collapse my-2 my-md-0 mr-md-3' : 'collapse navbar-collapse my-2 my-md-0 mr-md-3 show';
    const classTwo = collapsed ? 'navbar-toggler navbar-toggler-right collapsed' : 'navbar-toggler navbar-toggler-right';

    return (
      <header>
        <nav className="navbar navbar-expand-md navbar-light fixed-top"  id="publicNav">
          <div className="container">
            <a className="navbar-brand my-0 mr-md-auto" href={STATIC_PAGE_PATH}>
              <img
                alt="CoinMarketCap-logo"
                className="navbar-logo"
                src={publicUrl('/media/img/logo-square.png')}
              />
              <span className="navbar-brand-label">CoinMarketCap</span>
              <span className="navbar-brand-subheader">Developers</span>
            </a>
            <button onClick={this.toggleMenu} className={`${classTwo}`} type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className={`${classOne}`} id="navbarCollapse">
              <ul className="navbar-nav mr-auto">
                <li className={this.isPathActive(/v1/) ? "nav-item active" : "nav-item"} >
                  <a className="nav-link" href={DOCUMENTATION_PATH}>API&nbsp;Documentation</a>
                </li>
                <li className={this.isPathActive(/pricing/) || this.isPathActive('features') ? "nav-item active" : "nav-item"}>
                  <a className="nav-link" href={STATIC_PAGE_PATH+'pricing/'}>Pricing</a>
                </li>
                <li className={this.isPathActive(/faq/) ? "nav-item active" : "nav-item"}>
                  <a className="nav-link" href={STATIC_PAGE_PATH+'faq/'}>FAQ</a>
                </li>
                <li className="nav-item">
                  <a className="btn btn-outline-secondary text-uppercase" href={AUTHENTICATED_PAGE_PATH+'login/'}>Log In</a>
                </li>
              </ul>

            </div>
          </div>
        </nav>
      </header>
    );
  }
}

Navbar.propTypes = propTypes;

export default Navbar;



// WEBPACK FOOTER //
// ./client/pages/main/navbar.jsx